<template>
  <section class="section-block">
    <div class="container">
      <section-title
        kicker="Tin tức"
        title="Bài viết chuyên môn và cập nhật vận hành"
        description="Theo dõi kinh nghiệm thực tế và góc nhìn kỹ thuật trong lĩnh vực bảo trì, xử lý và tối ưu hệ thống nước."
      />
      <div class="row">
        <div v-for="post in posts" :key="post._id" class="col-lg-6 mb-4">
          <post-card :post="post" />
        </div>
      </div>
      <div class="d-flex justify-content-center mt-4">
        <b-pagination
          v-model="page"
          :total-rows="pagination.total"
          :per-page="pagination.limit"
          pills
          @input="loadPosts"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { fetchPosts } from "../../api/public";
import SectionTitle from "../../components/SectionTitle.vue";
import PostCard from "../../components/PostCard.vue";

export default {
  name: "NewsView",
  components: {
    SectionTitle,
    PostCard
  },
  data: function data() {
    return {
      page: 1,
      posts: [],
      pagination: {
        total: 0,
        limit: 6
      }
    };
  },
  created: function created() {
    this.loadPosts();
  },
  methods: {
    async loadPosts() {
      const response = await fetchPosts({
        page: this.page,
        limit: this.pagination.limit
      });

      this.posts = response.data.items;
      this.pagination = response.data.pagination;
    }
  }
};
</script>

